/** Please don't modify or unzip this content. It will be updated regularly **/
    (function() {
      BoostPFS.inject(this);

      //Set global variable
      Globals.hasIntegration = true;
      // 3rd app compile template
      Integration.compileIntegrationTemplate = function (data, itemHtml) {
        var itemReviewHtml = '<div class="grid-view-item__reviews"><div class="yotpo bottomLine" data-appkey="......." data-domain="' + Utils.escape(boostPFSConfig.shop.domain) + '" data-product-id="' + data.id + '" data-product-models="' + data.id + '" data-name="' + data.title + '" data-url="{{itemUrl}}" data-description="{{itemDescription}}" data-bread-crumbs="{{itemTags}}"></div></div>'; itemHtml = itemHtml.replace(/{{itemReviews}}/g, itemReviewHtml); var itemDescription = data.description ? data.description : ''; itemDescription = itemDescription.substr(0, itemDescription.indexOf('##highlights##')); itemHtml = itemHtml.replace(/{{itemDescription}}/g, itemDescription); itemHtml = itemHtml.replace(/{{itemTags}}/g, Utils.escape(data.tags.join(';')));itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data))
        return itemHtml;
      };

     
 Integration.call3rdIntegrationFunc = function(data) {
        if (typeof Yotpo !== 'undefined' && typeof window.yotpo !== 'undefined') {  var api = new Yotpo.API(window.yotpo);  api.refreshWidgets();}if (typeof yotpoWidgetsContainer !== 'undefined') {  yotpoWidgetsContainer.initWidgets();}

      }
    
       /*setTimeout(() => {
      Integration.call3rdIntegrationFunc = function(data) {
        if (typeof Yotpo !== 'undefined' && typeof window.yotpo !== 'undefined') {  var api = new Yotpo.API(window.yotpo);  api.refreshWidgets();}if (typeof yotpoWidgetsContainer !== 'undefined') {  yotpoWidgetsContainer.initWidgets();}
      }
       }, 3000); // Delay of 2000 milliseconds (2 seconds)
       
    if (typeof window.yotpoWidgetsContainer !== "undefined" && typeof window.yotpoWidgetsContainer.initWidgets === "function") {
        //window.yotpoWidgetsContainer.initWidgets();
         Integration.call3rdIntegrationFunc = function(data) {
        if (typeof Yotpo !== 'undefined' && typeof window.yotpo !== 'undefined') {  var api = new Yotpo.API(window.yotpo);  api.refreshWidgets();}if (typeof yotpoWidgetsContainer !== 'undefined') {  yotpoWidgetsContainer.initWidgets();}
      }
    } else {
        // Handle the case where Yotpo is not yet loaded or initWidgets is not available
        // This might involve retrying after a delay or logging an error.
         setTimeout(() => {
      Integration.call3rdIntegrationFunc = function(data) {
        if (typeof Yotpo !== 'undefined' && typeof window.yotpo !== 'undefined') {  var api = new Yotpo.API(window.yotpo);  api.refreshWidgets();}if (typeof yotpoWidgetsContainer !== 'undefined') {  yotpoWidgetsContainer.initWidgets();}
      }
       }, 3000); // Delay of 2000 milliseconds (2 seconds)
    }
*/
    })();